<template>
    <tr>
        <td>{{order.id}}</td>
        <td  style="max-width: 150px">
            <editable v-model="order.productdetail" :type="'textarea'" @edited="$emit('updateOrder')"></editable>
        </td>
        <td>
            <a target="_BLANK" :href="'https://www.facebook.com/' + selectedBot.pageid + '/inbox/?mailbox_id=' + selectedBot.pageid +'&selected_item_id='">{{order.first_name}} {{order.last_name}}</a>
            <editable v-model="order.nameaddress" :type="'textarea'" @edited="$emit('updateOrder')"></editable>
        </td>
        <td class="text-right">
            <editable v-model="order.amount" :filter="'decimal'" @edited="$emit('updateOrder')"></editable>
        </td>
        <td class="text-center" :class="{'warning' : order.status == 'ordered','info' : order.status == 'paid','success' : order.status == 'shipped','danger' : order.status == 'canceled'}">
            <select name="statusInput" id="statusInput" v-model="order.status" @change="$emit('onChangeStatus')">
                <option value="ordered">Ordered</option>
                <option value="paid">Paid</option>
                <option value="shipped">Shipped</option>
                <option value="canceled">Canceled</option>
            </select>
        </td>
        <td class="text-center">
            {{order.payment | capitalize}}
        </td>
        <td>     
            <img src="/static/img/assets/ecommerce/thailandpost_logo.png" class="img-responsive" v-if="order.shippingtype == 'normal'" style="max-width: 50px">
            <img src="/static/img/assets/ecommerce/ems_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'ems'" style="max-width: 50px">
            <img src="/static/img/assets/ecommerce/kerry_logo.png" class="img-responsive" v-else-if="order.shippingtype == 'kerry'" style="max-width: 50px">
            <hr style="margin: 7px 0">
            <template v-if="order.status == 'shipped'">
                <input type="text" v-model="order.trackingno" class="form-control" placeholder="Tracking No."><div style="padding-top:5px;"><a href="javascript:void(0);" class="btn btn-primary btn-sm" style="margin-right: 5px;margin-bottom: 5px;" @click="showPrint = true"><i class="fa fa-print"></i> Print</a><a href="javascript:void(0);" class="btn btn-default btn-sm" @click="$emit('updateOrder')">Send</a></div> 
                
            </template>
            <template v-else>
                {{order.trackingno}}
                <div style="padding-top:5px;"><a href="javascript:void(0);" class="btn btn-primary btn-sm" style="margin-right: 5px;margin-bottom: 5px;" @click="showPrint = true"><i class="fa fa-print"></i> Print</a></div>
            </template>
            <print-cover v-model="order" v-if="showPrint" @close="showPrint = false"></print-cover>
        </td>
        <td style="max-width: 200px">
            {{order.timestamp | moment("DD/MM/YYYY")}}<br>
            <editable v-model="order.note" :filter="'image'" :type="'image'" @edited="$emit('updateOrder')"></editable>
        </td>
    </tr>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import Editable from '@/components/elements/Editable'
import PrintCover from './PrintCover'

    export default {
        props: ['value'],
        data: function(){
            return {
                showPrint: false
            }
        },
        components: {
            Editable,
            PrintCover
        },
        computed: {
            ...mapGetters({
                selectedBot: 'selectedBot'
            }),
            order: function(){
                return this.value
            }
        },
        watch: {
            showPrint: function(newVal, oldVal) {
                if (newVal) {
                    $("body").addClass("modal-open");
                } else {
                    $("body").removeClass("modal-open");
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SummaryItem.vue